import { Check } from "lucide-react";
import { CtaButton } from "@/components/CtaButton";
import { Reveal, SectionHead, Em } from "@/components/Reveal";
import { BundleMockup } from "@/components/BundleMockup";
import { site } from "@/config/site.config";

const includes = [
  "The complete Wild Woman Millions experience",
  "Your personal Vision Blueprint work",
  "7 Quantum Habits™ daily rituals",
  "Three included digital books",
  "Bonus: The Blueprint belief-shift program",
  "Bonus: 7 Daily Rituals program",
  "Guided hypnosis + breathwork",
  "Meditations across the major areas of life",
  "Skool access included",
  "Instant digital access",
];

export const OfferSection = () => (
  <section data-testid="offer-section" className="border-y border-white/10 bg-coal">
    <div className="mx-auto max-w-6xl px-5 py-20 sm:py-28">
      <SectionHead eyebrow="INSIDE" center>
        WILD WOMAN
        <br />
        <Em>MILLIONS™</Em>
      </SectionHead>

      <Reveal className="mx-auto max-w-3xl py-6">
        <BundleMockup />
      </Reveal>

      <Reveal className="mx-auto mt-10 max-w-2xl text-center">
        <p className="font-mono text-[11px] tracking-[0.35em] text-lime">{site.method}</p>
        <p className="mt-5 text-base leading-relaxed text-cream/70">
          See the life you actually want. Choose it. Create the blueprint for it. Install the daily rituals.
          Expand the capacity to hold it. Turn what’s inside you into something real.
        </p>
      </Reveal>

      <Reveal className="mx-auto mt-10 max-w-2xl">
        <ul data-testid="offer-includes" className="grid gap-x-8 gap-y-3 sm:grid-cols-2">
          {includes.map((item) => (
            <li key={item} className="flex items-start gap-3 text-sm text-cream/80">
              <Check className="mt-0.5 h-4 w-4 shrink-0 text-lime" />
              {item}
            </li>
          ))}
        </ul>
      </Reveal>

      <Reveal className="mt-14 text-center">
        <p className="font-mono text-[11px] tracking-[0.35em] text-cream/50">EVERYTHING FOR</p>
        <p data-testid="offer-price" className="mt-2 font-serif text-7xl font-bold text-cream sm:text-8xl">
          {site.price}
        </p>
        <p className="mt-2 text-sm text-cream/60">One payment. No physical products shipped.</p>
        <div className="mt-8">
          <CtaButton id="offer">ENTER WILD WOMAN MILLIONS — {site.price}</CtaButton>
        </div>
        <p className="mt-3 font-mono text-[11px] tracking-[0.2em] text-cream/40">
          INSTANT ACCESS · EXPERIENCE + 3 DIGITAL BOOKS + BONUSES
        </p>
      </Reveal>
    </div>
  </section>
);
